import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { installFirebaseStorageServiceWorkerBypass } from './app/firebase-storage-network';

installFirebaseStorageServiceWorkerBypass();

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(() => {
    if (environment.production && 'serviceWorker' in navigator) {
      window.addEventListener('load', () => {
        void navigator.serviceWorker.register('/ngsw-firebase-bypass.js').catch(err => {
          console.warn('Service worker registration failed.', err);
        });
      });
    }
  })
  .catch(err => console.error(err));
